import {User} from './user.model';
import {UserAuthData} from './user-auth-data.model';

/**
 * Reprezentuje odpowiedź serwera po pomyślnej rejestracji nowego użytkownika.
 * Zwraca utworzony profil oraz dane autoryzacyjne, co pozwala na automatyczne rozpoczęcie sesji.
 */
export class UserSignupResponse {
  /** Nowo utworzony obiekt profilu użytkownika. */
  public user: User;
  /** Kontener z tokenami sesji pozwalający na natychmiastowe uwierzytelnienie. */
  public userAuthData: UserAuthData;

  constructor() {
  }
}
